import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';
import UnAuthenticatedRequest from '../services/requests/UnAuthenticated';
import { addQueryParameters } from '../utils/url';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/users`,
  SHOW: `${apiUrlConfig.apiEndPoint()}/users/:id`,
  UPDATE_EMAIL: `${apiUrlConfig.apiEndPoint()}/users/update_email`,
  ME: `${apiUrlConfig.apiEndPoint()}/users/me`,
  BUSINESS_USERS: `${apiUrlConfig.apiEndPoint()}/users/business_users`,
  CONFIRM_EMAIL: `${apiUrlConfig.endPoint()}/users/confirmation`,
  RESEND_CONFIRMATION: `${apiUrlConfig.apiEndPoint()}/users/resend_confirmation`,
};

function insertIdToUrl(url, id) {
  return url.replace(':id', id);
}

class UsersApi {
  /**
   * gets all users
   */
  static getAll() {
    return AuthenticatedRequestService.get(URLS.BUSINESS_USERS);
  }

  static getDetails(userId) {
    const SHOW_URL = insertIdToUrl(URLS.SHOW, userId);

    return AuthenticatedRequestService.get(SHOW_URL);
  }

  static resendConfirmation(email) {
    const data = {
      email,
    };
    return UnAuthenticatedRequest.post(URLS.RESEND_CONFIRMATION, data);
  }

  static getMyDetails() {
    return AuthenticatedRequestService.get(URLS.ME);
  }

  static addNewUser(userData) {
    const data = {
      user: userData,
    };

    return UnAuthenticatedRequest.post(URLS.INDEX, data);
  }

  static updateUserInfo(id, userData) {
    const data = {
      user: userData,
    };
    const indexUrl = insertIdToUrl(URLS.SHOW, id);
    return AuthenticatedRequestService.patch(indexUrl, data);
  }

  static updateEmail(emailData) {
    return UnAuthenticatedRequest.post(URLS.UPDATE_EMAIL, emailData);
  }

  static confirmEmail(token) {
    const INDEX_URL = addQueryParameters(URLS.CONFIRM_EMAIL, token);

    return UnAuthenticatedRequest.get(INDEX_URL);
  }
}

export default UsersApi;



// WEBPACK FOOTER //
// ./src/apis/Users.js